function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { ThemeProvider } from "styled-components";
export default function Theme({
  mode,
  ...props
}) {
  return /*#__PURE__*/React.createElement(ThemeProvider, _extends({
    theme: {
      mode
    }
  }, props));
}
//# sourceMappingURL=Theme.js.map